/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ branches: NonNullable<unknown>, stores: NonNullable<unknown> }} Sitesettings_Hint_Store_System1Inputs */

const vi_sitesettings_hint_store_system1 = /** @type {(inputs: Sitesettings_Hint_Store_System1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.branches} = số chi nhánh, ${i?.stores} = số cửa hàng.`)
};

/**

* @param {Sitesettings_Hint_Store_System1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_hint_store_system1 = /** @type {((inputs: Sitesettings_Hint_Store_System1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Hint_Store_System1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_hint_store_system1(inputs)
});
export { sitesettings_hint_store_system1 as "siteSettings_hint_store_system" }